// Types of reordering that can be done in different parts of the app
export enum ReorderType {
  OrgInsightCards = 'OrgInsightCards',
  OrgHomeSections = 'OrgHomeSections',
  PathwayNodes = 'PathwayNodes',
  PlanNodes = 'PlanNodes',
}
